import Backbone from 'backbone';
import $ from 'jquery';
import template from '../template/filterBanner.pug';

export class RecommendationFilterBanner extends Backbone.View {
  initialize({
    opportunityIds,
    i18n,
    view,
    removeFilter,
    reason,
  }) {
    this.opportunityIds = opportunityIds;
    this.i18n = i18n;
    this.view = view;
    this.removeFilter = removeFilter;
    this.reason = reason;
  }

  get events() {
    return {
      'click .remove': this.remove,
    };
  }

  remove() {
    this.removeFilter(this.view.grid.gridView, this.opportunityIds);
    $('.filterBanner').remove();
  }


  render() {
    const model = {
      i18n: this.i18n,
      message: this.i18n.getString(
        'Recommendation_Notification_Filter_Banner_Text',
        { reason: this.reason }
      ),
    };
    this.$el.html(template(model));

    return this;
  }
}
